import React from 'react'
import ThumbnailCard from './ThumbnailCard'
import { Row} from 'react-bootstrap'

type ThumbnailListProps = {
    dashboardNames: string[]
}

const ThumbnailList: React.FC<ThumbnailListProps> = ({ dashboardNames }: ThumbnailListProps) => {
    return (
        <Row>
            {dashboardNames.map(dashboardName => (
                // eslint-disable-next-line react/jsx-key
                <ThumbnailCard dashboardName={dashboardName} />
            ))}
        </Row>
    )
}

export default ThumbnailList
